module.exports = __webpack_public_path__ + "img/h7.b7a69f06.png";